<script>
  import RouterLink from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import moment from 'moment';

  export let report;

  function getReportURL() {
    return report.url;
  }
</script>

<Card hover="{true}">
  <div class="u--padall">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9">
        <h3>
          {report.name}
        </h3>
        <p>{report.description}</p>
      </div>
    </div>
  </div>
  <hr />
  <div class="stat">
    <div class="grid-x">
      <div class="cell small-12 medium-12">
        <a href="{getReportURL()}" target="_blank"
          ><div class="button primary">Run Report</div></a
        >
      </div>
    </div>
  </div>
</Card>
